let imgPath = (path) => {
    if(path){
        if(!path.startsWith("http")){
            return 'http://caiec.org.cn/exam-api/file/' + path
        }else{
            return path
        }
    }else{
        return path
    } 
}
export {
    imgPath
}



// WEBPACK FOOTER //
// ./src/config/imgPath.js